const { sessionStorage } = window;

export function getItem(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (er) {
    return '';
  }
}

export function setItem(key, value) {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch (er) {
    return false;
  }
}

export function clear() {
  try {
    sessionStorage.clear();
    return true;
  } catch (er) {
    return false;
  }
}

export function removeItem(key) {
  try {
    sessionStorage.removeItem(key);
    return true;
  } catch (er) {
    return false;
  }
}

export default {
  getItem,
  setItem,
  removeItem,
  clear,
};
